import { render, staticRenderFns } from "./TokenBreakDown.vue?vue&type=template&id=da8c2bfe&scoped=true&"
import script from "./TokenBreakDown.vue?vue&type=script&lang=js&"
export * from "./TokenBreakDown.vue?vue&type=script&lang=js&"
import style0 from "./TokenBreakDown.vue?vue&type=style&index=0&id=da8c2bfe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "da8c2bfe",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
